/**
 * Values for the training-log distance field.
 * Strava stores whole meters. Distances of 1 km or more are edited in
 * kilometers, which needs three decimal places (15.234 km = 15234 m).
 */

export function trainingLogDistanceField(meters) {
  const value = Number(meters);
  if (!Number.isFinite(value) || value <= 0) {
    return { distance: '', unit: 'meters' };
  }

  const roundedMeters = Math.round(value);
  if (roundedMeters >= 1000) {
    const kmText = (roundedMeters / 1000)
      .toFixed(3)
      .replace(/0+$/, '')
      .replace(/\.$/, '');
    return { distance: kmText, unit: 'km' };
  }

  return { distance: String(roundedMeters), unit: 'meters' };
}
